import type { CSSProperties } from 'react';
import TriangleDownIconSvg from '../../assets/icons/triangle_down.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const TriangleDownIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <TriangleDownIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default TriangleDownIcon;
